import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import { FaFileInvoiceDollar, FaWhatsapp, FaEnvelope, FaChevronDown, FaChevronUp, FaCalendarAlt } from 'react-icons/fa';
import './holerite.css';

const Holerite = () => {
    const [holerites, setHolerites] = useState([]);
    const [detalhesVisiveis, setDetalhesVisiveis] = useState({});
    const isMobile = window.innerWidth < 768;
    const chapa = localStorage.getItem("chapa");
    const navigate = useNavigate();

    useEffect(() => {
        const chapaStorage = localStorage.getItem("chapa");
        if (!chapaStorage) {
            navigate("/arbor/login");
        }
    }, [navigate]);

    useEffect(() => {
        const fetchHolerites = async () => {
            if (!chapa) return;
            try {
                const res = await api.get(`/usuario/holerite/${chapa}`);
                setHolerites(res.data);
            } catch (err) {
                console.error('Erro ao buscar holerites:', err);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Não foi possível carregar os holerites.',
                    confirmButtonColor: '#8b0000'
                });
            }
        };

        fetchHolerites();
    }, [chapa]);

    const padMesAno = (mes, ano) => {
        return `${mes.toString().padStart(2, '0')}${ano}`;
    };

    const toggleDetalhes = async (index, periodo, mes, ano) => {
        const key = `${index}`;
        const visiveis = { ...detalhesVisiveis };

        if (visiveis[key]) {
            visiveis[key] = null;
        } else {
            try {
                const res = await api.get(`/usuario/holerite/${chapa}/selecionado?periodo=${periodo}&mesano=${padMesAno(mes, ano)}`);
                visiveis[key] = res.data;
            } catch (err) {
                console.error('Erro ao buscar detalhes do holerite:', err);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Erro ao carregar detalhes do holerite.',
                    confirmButtonColor: '#8b0000'
                });
                return;
            }
        }

        setDetalhesVisiveis(visiveis);
    };

    const aplicarMascaraCelular = (value) => {
        const numeros = value.replace(/\D/g, '').slice(0, 11);

        if (numeros.length <= 2) {
            return `(${numeros}`;
        } else if (numeros.length <= 7) {
            return `(${numeros.slice(0, 2)}) ${numeros.slice(2)}`;
        } else if (numeros.length <= 11) {
            return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 3)} ${numeros.slice(3, 7)}-${numeros.slice(7)}`;
        }
    };

    const limparMascaraCelular = (value) => {
        return value.replace(/\D/g, '');
    };

    const enviar = async (tipo, periodo, mes, ano, dados) => {
        const contatoPadrao = tipo === 'whatsapp'
            ? aplicarMascaraCelular(dados?.telefone2 || '')
            : (dados?.email || '');

        const { value: destino } = await Swal.fire({
            title: `Enviar via ${tipo === 'email' ? 'E-mail' : 'WhatsApp'}`,
            input: 'text',
            inputLabel: `Informe o ${tipo === 'email' ? 'e-mail' : 'número de WhatsApp'}:`,
            inputValue: contatoPadrao,
            showCancelButton: true,
            confirmButtonText: 'Enviar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#8b0000',
            didOpen: () => {
                if (tipo === 'whatsapp') {
                    const input = Swal.getInput();
                    input.addEventListener('input', () => {
                        input.value = aplicarMascaraCelular(input.value);
                    });
                }
            },
            inputValidator: (value) => {
                if (!value) {
                    return `Informe um ${tipo === 'email' ? 'e-mail' : 'número de WhatsApp'} válido!`;
                }
            }
        });

        if (destino) {
            const numeroFinal = tipo === 'whatsapp' ? limparMascaraCelular(destino) : destino;

            try {
                console.log(tipo+' - '+periodo+' - '+mes+' - '+ano+ ' - '+destino);    
                await api.post(`/usuario/holerite/${chapa}`, {
                    tipo,
                    periodo,
                    mes,
                    ano,
                    destino: numeroFinal
                });
                Swal.fire({
                    icon: 'success',
                    title: 'Enviado',
                    text: `Holerite enviado por ${tipo === 'email' ? 'e-mail' : 'WhatsApp'} para ${destino}.`,
                    confirmButtonColor: '#8b0000'
                });
            } catch (err) {
                console.error('Erro ao enviar holerite:', err);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Não foi possível enviar o holerite.',
                    confirmButtonColor: '#8b0000'
                });
            }
        }
    };

    return (
        <div className="bg-light min-vh-100" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
            <Menu modulo="ARBOR" />

            <div 
                className="container-fluid py-3 px-3 px-md-5"
                style={{ maxWidth: '1280px', margin: '0 auto' }}
            >
                {/* Título da Página */}
                <div className="d-flex align-items-center mb-4">
                    <FaFileInvoiceDollar className="me-2 text-danger fs-3" />
                    <div>
                        <h4 className="fw-bold m-0 text-dark">Meus Holerites</h4>
                        <small className="text-muted">Consulte os seus recibos de pagamento de salário e benefícios</small>
                    </div>
                </div>

                {holerites.length === 0 ? (
                    <div className="card border-0 shadow-sm rounded-4 p-5 text-center bg-white">
                        <FaFileInvoiceDollar className="text-muted opacity-50 mb-3 mx-auto" size={48} />
                        <h5 className="fw-bold text-dark mb-1">Nenhum holerite disponível</h5>
                        <p className="text-muted small mb-0">Seus recibos de pagamento aparecerão aqui assim que forem liberados pelo RH.</p>
                    </div>
                ) : (
                    holerites.map((item, index) => (
                        <div 
                            key={index} 
                            className="card mb-3 overflow-hidden border-0 shadow-sm rounded-4 holerite-card-clean"
                        >
                            {/* Cabeçalho do Card */}
                            <div
                                className="p-3 d-flex justify-content-between align-items-center cursor-pointer border-bottom bg-white flex-wrap gap-2"
                                onClick={() => toggleDetalhes(index, item.holf_periodo, item.holf_mes, item.holf_ano)}
                            >
                                <div className="d-flex align-items-center gap-3 flex-wrap">
                                    <div>
                                        <span className="fw-bold fs-6 text-dark d-block">
                                            {item.holf_mes.toString().padStart(2, '0')}/{item.holf_ano} - <span className="text-danger-header">{item.desc_periodo}</span>
                                        </span>
                                        <small className="text-muted fw-medium d-flex align-items-center gap-1 mt-0.5" style={{ fontSize: '0.8rem' }}>
                                            <FaCalendarAlt size={12} className="text-secondary" /> Liberado em: {item.holf_datahora}
                                        </small>
                                    </div>

                                    {item.holf_mensagem && (
                                        <span className="badge holf_mensagem px-3 py-1.5 rounded-3">
                                            {item.holf_mensagem}
                                        </span>
                                    )}
                                </div>

                                <button 
                                    type="button" 
                                    className="btn btn-sm btn-outline-danger fw-bold d-flex align-items-center gap-1 ms-auto ms-md-0"
                                >
                                    {detalhesVisiveis[index] ? (
                                        <><span>Ocultar</span> <FaChevronUp /></>
                                    ) : (
                                        <><span>Detalhes</span> <FaChevronDown /></>
                                    )}
                                </button>
                            </div>

                            {/* Conteúdo Expandido */}
                            {detalhesVisiveis[index] && (
                                <div className="card-body p-3 bg-white border-top">
                                    {/* 🖥️ Visão Desktop (Tabela Completa) */}
                                    {!isMobile ? (
                                        <div className="table-responsive mb-4">
                                            <table className="table table-hover align-middle m-0 small">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th className="text-center py-2">Evento</th>
                                                        <th className="text-start py-2">Descrição</th>
                                                        <th className="text-end py-2">Referência</th>
                                                        <th className="text-end py-2">Provento</th>
                                                        <th className="text-end py-2">Desconto</th>
                                                        <th className="text-end py-2">Base</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {detalhesVisiveis[index].itens.map((linha, idx) => (
                                                        <tr key={idx}>
                                                            <td className="text-center fw-semibold text-secondary">{linha.cod}</td>
                                                            <td className="text-start fw-semibold text-dark">{linha.descricao}</td>
                                                            <td className="text-end text-muted">{linha.ref}</td>
                                                            <td className="text-end fw-bold text-success">{linha.valprovento || ''}</td>
                                                            <td className="text-end fw-bold text-danger">{linha.valdesconto || ''}</td>
                                                            <td className="text-end text-secondary">{linha.valbase || ''}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        /* 📱 Visão Mobile (Lista de Eventos em Cards) */
                                        <div className="mb-3">
                                            {detalhesVisiveis[index].itens.map((linha, idx) => (
                                                <div key={idx} className="p-2.5 mb-2 rounded-3 border bg-light">
                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                        <span className="fw-bold text-dark small">{linha.cod} - {linha.descricao}</span>
                                                        <span className="text-muted extra-small">Ref: {linha.ref}</span>
                                                    </div>
                                                    <div className="d-flex justify-content-end gap-3 pt-1 border-top extra-small">
                                                        {linha.valprovento && (
                                                            <span className="fw-bold text-success">Provento: {linha.valprovento}</span>
                                                        )}
                                                        {linha.valdesconto && (
                                                            <span className="fw-bold text-danger">Desconto: {linha.valdesconto}</span>
                                                        )}
                                                        {linha.valbase && (
                                                            <span className="text-secondary">Base: {linha.valbase}</span>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    {/* Resumo e Totais do Holerite */}
                                    <div className="row text-center g-2 mb-4 p-2 rounded-3 bg-light border">
                                        {['salario', 'baseinss', 'basefgts', 'fgts', 'baseirrf', 'faixairrf', 'totvenc', 'totdesc', 'valliq'].map((campo, idx) => (
                                            <div key={idx} className="col-4 col-md">
                                                <small className="text-muted d-block text-uppercase extra-small fw-semibold mb-1">
                                                    {!isMobile 
                                                        ? campo.replace('totvenc', 'Total Venc.').replace('totdesc', 'Total Desc.').replace('valliq', 'Líquido').replace('faixairrf', 'Faixa IRRF').replace('baseirrf', 'Base IRRF').replace('fgts', 'FGTS').replace('basefgts', 'Base FGTS').replace('baseinss', 'Base INSS').replace('salario', 'Salário Base')
                                                        : campo.replace('totvenc', 'T.Venc').replace('totdesc', 'T.Desc').replace('valliq', 'Líquido').replace('faixairrf', 'F.IRRF').replace('baseirrf', 'B.IRRF').replace('fgts', 'FGTS').replace('basefgts', 'B.FGTS').replace('baseinss', 'B.INSS').replace('salario', 'Sal. Base')
                                                    }
                                                </small>
                                                <div className={`p-1.5 bg-white rounded border fw-bold small ${campo === 'totdesc' ? 'text-danger' : campo === 'totvenc' || campo === 'valliq' ? 'text-success' : 'text-dark'}`}>
                                                    {detalhesVisiveis[index][campo] || '0,00'}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Botões de Ação para Envio */}
                                    <div className="d-flex justify-content-end gap-2 flex-wrap">
                                        <button 
                                            className="btn btn-sm btn-outline-success fw-bold d-flex align-items-center gap-1.5 px-3 py-1.5 rounded-3" 
                                            onClick={() => enviar('whatsapp', item.holf_periodo, item.holf_mes, item.holf_ano, detalhesVisiveis[index])}
                                        >
                                            <FaWhatsapp size={16} /> Enviar WhatsApp
                                        </button>
                                        <button 
                                            className="btn btn-sm btn-outline-dark fw-bold d-flex align-items-center gap-1.5 px-3 py-1.5 rounded-3" 
                                            onClick={() => enviar('email', item.holf_periodo, item.holf_mes, item.holf_ano, detalhesVisiveis[index])}
                                        >
                                            <FaEnvelope size={14} /> Enviar e-mail
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    ))
                )}
            </div>

            <Footer />
        </div>
    );
};

export default Holerite;